
import React, { useCallback, useEffect, useState } from 'react';
import S from './styles.js';

const ModalHubSpot = ({ titulo, visivel, setVisivel }) => {
  const [isLoading, setIsLoading] = useState(false);

  const onCancel = () => {
    setVisivel(false);
    const container = document.getElementById('33c7e66a-1d45-4674-bf03-2744ebe99816');
      if (container) {
        container.innerHTML = '';
      }
  };

  const loadHubSpotScript = useCallback(() => {
    setIsLoading(true);
    const container = document.getElementById('33c7e66a-1d45-4674-bf03-2744ebe99816');
    if (container) container.innerHTML = '';
    if (window.HubSpotForms) {
      initializeForm();
      return;
    }
    // Verifica se o script já existe
    if (document.querySelector('script[src*="50794376.js"]')) {
      // Aguarda o script carregar e inicializa
      const interval = setInterval(() => {
        if (window.HubSpotForms) {
          clearInterval(interval);
          initializeForm();
        }
      }, 50);
      return;
    }
    const script = document.createElement('script');
    script.src =
      'https://js.hsforms.net/forms/embed/50794376.js';
    script.async = true;
    script.onload = () => {
      initializeForm();
    };
    script.onerror = () => {
      console.error('Erro ao carregar script do HubSpot');
      setIsLoading(false);
    };
    document.head.appendChild(script);
  }, []);

  const initializeForm = () => {
    try {
      if (!window.HubSpotForms) return;
      const container = document.getElementById('33c7e66a-1d45-4674-bf03-2744ebe99816');
      if (!container) {
        setIsLoading(false);
        return;
      }
      // Se já existe conteúdo (segunda abertura) não recria para evitar duplicação
      if (container.children.length > 0) {
        setIsLoading(false);
        return;
      }
      new window.HubSpotForms(
        '33c7e66a-1d45-4674-bf03-2744ebe99816',
        '50794376'
      ).createForm();
      setIsLoading(false);
    } catch (error) {
      console.error('Erro ao inicializar formulário HubSpot:', error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (visivel) {
      // É necessário esperar um pouquinho pra garantir que o script foi carregado
      const timer = setTimeout(() => {
        loadHubSpotScript();
      }, 100);
      return () => clearTimeout(timer);
    }

    const container = document.getElementById('33c7e66a-1d45-4674-bf03-2744ebe99816');
      if (container) {
        container.innerHTML = '';
      }
    return undefined;
  }, [loadHubSpotScript, visivel]);

  if (!visivel) {
    return null;
  }

  return (
    <S.Modal
      key="modal-hubspot"
      title={<h4 style={{ fontSize: '1.1rem', fontWeight: 600 }}>{titulo}</h4>}
      visible={visivel}
      width={784}
      centered
      destroyOnClose
      onCancel={onCancel}
      footer={null}
    >
      {isLoading && (
        <div style={{ textAlign: 'center', padding: '20px' }}>Carregando formulário...</div>
      )}
      <div
        id="modal-hubspot-content"
        style={{
          width: '100%',
          minHeight: '200px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <div
          role="main"
          id="33c7e66a-1d45-4674-bf03-2744ebe99816"
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        />
      </div>
    </S.Modal>
  );
};

export default ModalHubSpot;
